import AddIcon from "@mui/icons-material/Add";
import HtmlIcon from "@mui/icons-material/Html";
import { Button, Card, CardActionArea, CardHeader, CardMedia, CircularProgress, Divider, Grid, List, ListItemButton, ListItemText, SvgIcon, TextField } from "@mui/material";
import { child, get, getDatabase, ref } from "firebase/database";
import React from "react";
import { Link } from "react-router-dom";

import FirebaseApp from "../FirebaseInit";
import errorDialog from "../Functions/error";

export default function GameLibrary() {

    const [libraryChildren, libraryChildrenSet] = React.useState<React.ReactNode | string>(<div style={{ display: "flex", justifyContent: "center", marginTop: "24px", width: "100%" }}><CircularProgress /></div>);
    const [searchResults, searchResultsSet] = React.useState<React.ReactNode | string>(<div style={{ display: "flex", justifyContent: "center", marginTop: "24px", width: "100%" }}><CircularProgress /></div>);
    const [run, runSet] = React.useState<boolean>(true);
    const [globalGamesObject, globalGamesObjectSet] = React.useState<Object>({});
    const [globalGamesObjectCodenames, globalGamesObjectCodenamesSet] = React.useState<string[]>([]);
    const inputRef: React.MutableRefObject<HTMLInputElement | null> = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        document.title = "Game Library | Wake Students";
    }, []);

    // handles search bar
    const searchFunction = (event: React.ChangeEvent<HTMLInputElement> | { target: { value: string } }) => { // added second type so we can call manually in the FeaturedGame component
        if (event.target.value) {
            document.getElementById("gameLibraryList")?.classList.add("d-none");
            document.getElementById("searchResults")?.classList.remove("d-none");

            searchResultsSet(
                <>
                    {
                        Object.values(globalGamesObject) //im gonna be so fr i have no idea what the fuck the code i copied does, but the 
                            .map((item, index) => ({ item, index })) // code from under this for the game library didnt work because the
                            .filter(({ item }) => ((item.fullName + item.type + item.description).toLowerCase()).includes(event.target.value.toLowerCase())) // index being returned was the new one
                            .map(({ item, index }) => (<> {/* not the old one, which is bad for the codenames array*/}
                                <Divider />
                                <ListItemButton component={Link} to={`/game/${globalGamesObjectCodenames[index]}`} style={{ padding: "0" }}>
                                    <img alt={item.fullName} src={`https://wakestudents.github.io/static/images/games/${globalGamesObjectCodenames[index]}.webp`} style={{ maxWidth: "7rem", marginRight: "1rem" }} />
                                    <ListItemText primary={item.fullName} secondary={item.description} />
                                    <div style={{ marginRight: ".5rem", marginLeft: ".5rem" }}>
                                        {item.type === "html" ? < HtmlIcon /> : <SvgIcon viewBox="0 0 16 16" ><path style={{ fill: "#fff" }} d="M13,4.4C10,4.4,9.7,7,9.7,7H11v2H8.6C6.8,14.8,3,14,3,14v-2.5c0,0,2.5,0.6,3.9-4C8.7,1.4,13,2,13,2V4.4z" /></SvgIcon>}
                                    </div>
                                </ListItemButton>
                            </>))
                    }
                </>);
        } else {
            document.getElementById("gameLibraryList")?.classList.remove("d-none");
            document.getElementById("searchResults")?.classList.add("d-none");

        }
    }
    function FeaturedGame(props: { image: string, name: string, inputRef: React.MutableRefObject<any>, search?: string }) {
        return (
            <Grid item>
                <Card>
                    <CardActionArea onClick={() => { props?.inputRef?.current.focus(); props.inputRef.current.value = props.name; props.search ? searchFunction({ target: { value: props.search } }) : searchFunction({ target: { value: props.name } }); }}> {/* so i couldnt figure out how to fire the input's onChange, so i just jerryrigged the search function in here*/}
                        <div style={{ display: "flex" }}>
                            <CardMedia
                                component="img"
                                image={props.image}
                                alt={props.name}
                                style={{ maxHeight: "5rem", width: "auto" }}
                            />
                            <CardHeader title={props.name} />
                        </div>
                    </CardActionArea>
                </Card>
            </Grid>
        )
    }

    if (run) {
        runSet(false);
        const database = ref(getDatabase(FirebaseApp));

        get(child(database, "/favoritesMetadata/")).then((snapshot) => {
            let gamesObject: Object = {};
            if (snapshot.exists()) {
                gamesObject = snapshot.val();
                globalGamesObjectSet(gamesObject);
            } else {
                console.log("No data available");
                errorDialog("No library data available", "Firebase is not reporting any data for the games library. Serious issue.")
            }
            let gamesObjectCodenames = Object.keys(gamesObject);
            globalGamesObjectCodenamesSet(Object.keys(gamesObject));
            libraryChildrenSet(
                <>
                    {
                        Object.values(gamesObject).map((item, index) => (
                            <>
                                <Divider />
                                <ListItemButton component={Link} to={`/game/${gamesObjectCodenames[index]}`} style={{ padding: "0" }}>
                                    <img alt={item.fullName} src={`https://wakestudents.github.io/static/images/games/${gamesObjectCodenames[index]}.webp`} style={{ maxWidth: "7rem", marginRight: "1rem" }} />
                                    <ListItemText primary={item.fullName} secondary={item.description} />
                                    <div style={{ marginRight: ".5rem", marginLeft: ".5rem" }}>
                                        {item.type === "flash" ? <SvgIcon viewBox="0 0 16 16" ><path d="M13,4.4C10,4.4,9.7,7,9.7,7H11v2H8.6C6.8,14.8,3,14,3,14v-2.5c0,0,2.5,0.6,3.9-4C8.7,1.4,13,2,13,2V4.4z" /></SvgIcon> : <HtmlIcon />}
                                    </div>
                                </ListItemButton>
                            </>
                        ))
                    }
                </>);

        }).catch((error) => {
            console.error(error);
        });
    }
    return (
        <div className="game-library">
            <Card style={{ marginBottom: "1rem" }}>
                <CardHeader title="Games Library" action={<><Button component="a" href="https://docs.google.com/forms/d/e/1FAIpQLSeK0jht3XipUwtRqyyn-V7axpF7xGJnB1A1zKJjqPU-GCtkVQ/viewform" target="_blank" style={{ marginTop: "2px" }} startIcon={<AddIcon />}>Request a Game</Button></>} />
            </Card>
            <Grid container spacing={2} marginBottom="1rem">
                <FeaturedGame inputRef={inputRef} image="https://wakestudents.github.io/static/images/games/papasPizzeria.webp" name="Papa's" />
                <FeaturedGame inputRef={inputRef} image="https://wakestudents.github.io/static/images/games/duckLife1.webp" name="Duck Life" />
                <FeaturedGame inputRef={inputRef} image="https://wakestudents.github.io/static/images/games/worldsHardestGame3.webp" name="World's Hardest Game" />
            </Grid>
            <Card>
                <List style={{ marginLeft: "1rem", marginRight: "1rem", paddingBottom: "1rem", paddingTop: "1rem" }}>
                    <TextField id="fortnite" inputRef={inputRef} label="Search games" variant="filled" fullWidth onChange={searchFunction} />
                    <div id="searchResults" className="d-none" style={{ borderRadius: "10px" }}>
                        {searchResults}
                    </div>
                    <div id="gameLibraryList" style={{ borderRadius: "10px" }}>
                        {libraryChildren}
                    </div>
                </List>
            </Card>
        </div>
    );
}